<!--  -->
<template>
    <div class=''>
        <div id="webgl" style=""></div>

    </div>
</template>

<script>

import * as THREE from 'three';
import { OrbitControls } from 'three/addons/controls/OrbitControls.js' //相机控件
export default {
    components: {},
    data() {
        return {

        }
    },
    // 监听属性 类似于data概念
    computed: {},
    // 监控data中的数据变化
    watch: {},
    // 方法集合
    methods: {
        init() {
            // 创建3D场景对象Scene
            const scene = new THREE.Scene();
            //创建一个长方体几何对象Geometry
            const geometry = new THREE.BoxGeometry(50, 50, 50);
            //创建一个材质对象Material
            const material = new THREE.MeshLambertMaterial({
                color: 0xff0000,//0xff0000设置材质颜色为红色
                transparent: false,//开启透明
                // opacity: 0.5,//设置透明度
            });
            // 两个参数分别为几何体geometry、材质material
            const mesh = new THREE.Mesh(geometry, material); //网格模型对象Mesh
            mesh.position.set(0, 0, 0);
            scene.add(mesh);


            // AxesHelper：辅助观察的坐标系
            const axesHelper = new THREE.AxesHelper(100);
            scene.add(axesHelper);




            //点光源：两个参数分别表示光源颜色和光照强度
            // 参数1：0xffffff是纯白光,表示光源颜色
            // 参数2：1.0,表示光照强度，可以根据需要调整
            const pointLight = new THREE.AmbientLight(0xffffff, 1.0);
            pointLight.decay = 2.0
            // pointLight.intensity = 100
            //点光源位置
            pointLight.position.set(200, 100, 300);//点光源放在x轴上
            scene.add(pointLight); //点光源添加到场景中
            // 光源辅助观察
            const pointLightHelper = new THREE.PointLightHelper(pointLight, 10);
            scene.add(pointLightHelper);


            // const pointLight2 = new THREE.DirectionalLight(0xffffff, 1.0);
            // pointLight2.decay = 2.0
            // // pointLight.intensity = 100
            // //点光源位置
            // pointLight2.position.set(-200, -100, -300);//点光源放在x轴上
            // scene.add(pointLight2); //点光源添加到场景中

            //渲染到页面上
            // 实例化一个透视投影相机对象
            // width和height用来设置Three.js输出的Canvas画布尺寸(像素px)
            const width = 1800; //宽度
            const height = 800; //高度
            // 30:视场角度, width / height:Canvas画布宽高比, 1:近裁截面, 3000：远裁截面
            const camera = new THREE.PerspectiveCamera(30, width / height, 1, 3000);

            //相机在Three.js三维坐标系中的位置
            // 根据需要设置相机位置具体值
            camera.position.set(400, 400, 400);
            //相机观察目标指向Threejs 3D空间中某个位置
            camera.lookAt(0, 0, 0); //坐标原点

            // 创建渲染器对象
            const renderer = new THREE.WebGLRenderer();
            // 定义threejs输出画布的尺寸(单位:像素px)
            renderer.setSize(width, height); //设置three.js渲染区域的尺寸(像素px)
            renderer.render(scene, camera); //执行渲染操作
            document.getElementById('webgl').appendChild(renderer.domElement);


            //创建相机控制对象
            const controls = new OrbitControls(camera, renderer.domElement)
            // 如果OrbitControls改变了相机参数，重新调用渲染器渲染三维场景
            controls.addEventListener('change', function () {
                renderer.render(scene, camera); //执行渲染操作
            });//监听鼠标、键盘事件

        }
    },
    // 生命周期 - 创建完成（可以访问当前this实例）
    created() {

    },
    // 生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {
        this.init()
    },
    beforeCreate() { }, // 生命周期 - 创建之前
    beforeMount() { }, // 生命周期 - 挂载之前
    beforeUpdate() { }, // 生命周期 - 更新之前
    updated() { }, // 生命周期 - 更新之后
    beforeDestroy() { }, // 生命周期 - 销毁之前
    destroyed() { }, // 生命周期 - 销毁完成
    activated() { } // 如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style lang='scss' scoped></style>